import * as React from 'react';
import { PopoverContent } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

/**
 * Owner-scoped variant of `PopoverContent`. Neutralises the legacy neobrutalist
 * border inherited by the shared shadcn primitive (used by marketing/admin),
 * applies the `/owner/*` soft-shadow + slate-200 border language.
 *
 * Always prefer this over the raw `PopoverContent` for any popover rendered
 * inside `[data-app-shell="owner"]`.
 */

const ownerPopoverContentClass = cn(
  // override border-width arbitrary value from base PopoverContent
  'border! border-charcoal-200! border-[length:1px]!',
  'rounded-xl bg-white p-1.5',
  'shadow-[0_12px_32px_-12px_rgba(15,23,42,0.2),0_4px_8px_-4px_rgba(15,23,42,0.06)]',
  'dark:border-charcoal-700! dark:bg-charcoal-850',
  'dark:shadow-[0_16px_32px_-12px_rgba(0,0,0,0.5)]',
);

type OwnerPopoverContentProps = React.ComponentProps<typeof PopoverContent>;

export function OwnerPopoverContent({ className, ...props }: OwnerPopoverContentProps) {
  return <PopoverContent className={cn(ownerPopoverContentClass, className)} {...props} />;
}
